function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.687 28.64c.112-.551.267-1.1.469-1.644 2.103-5.675 8.408-8.57 14.083-6.468 5.675 2.103 8.57 8.408 6.467 14.083a11.043 11.043 0 01-.736 1.589m-1.684 2.248a10.96 10.96 0 01-11.663 2.63c-4.374-1.62-7.097-5.638-7.152-10.04"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.37 30.34c9.627 4.227 15.993 8.381 15.321 10.197-.857 2.312-12.967-.044-27.049-5.263C12.56 30.056 1.838 23.951 2.695 21.64c.634-1.71 7.42-.866 16.609 1.8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.297 32.04c5.713 2.575 9.395 4.822 9.065 5.713-.483 1.305-9.395-.794-19.904-4.689C16.95 29.17 8.822 24.954 9.305 23.65c.3-.81 3.848-.308 9.01 1.12"
}));

var SvgPlanet = function SvgPlanet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlanet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Planet.b62d2f47.svg";
export { ForwardRef as ReactComponent };